<template>
  <div class="content">
    <template v-if="applications?.length">
      <div class="card card--banner" v-if="hasBeenEnrolled && !readonly">
        <img class="card__icon icon icon--primary" src="~images/info.svg" v-svg-inline/>
        <p>
          Поздравляем с поступлением!
          <br>
          Подробную информацию можно найти в заявлении со статусом <strong>Зачислен</strong>
          во вкладке <strong>Обзор</strong>
        </p>
      </div>
      <div class="table table--vertical table--lorem">
        <table class="table__inner">
          <colgroup>
            <col span="1" style="width: 45%;">
            <col span="1" style="width: 20%;">
            <col span="1" style="width: 15%;">
            <col span="1" style="width: 12%;">
          </colgroup>
          <thead class="table__thead">
            <tr class="table__tr">
              <th class="table__th">Заявление</th>
              <th class="table__th">Статус</th>
              <th class="table__th">Обновлено</th>
              <th class="table__th">Действия</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table__tr" v-for="application in applications" :key="application.id">
              <td class="table__td" data-title="Заявление">
                <a href="#" @click.prevent="$emit('select', application)">
                  №{{ application.sspvo_unique_code }} ({{ application.education_level }})
                </a>
              </td>
              <td class="table__td" data-title="Статус">
                <span class="join join--center">
                  {{ application.status_text }}
                  <span
                    v-if="application.email_matched === false"
                    v-tooltip="{ content: APPLICATION_EMAIL_NOT_MATCHED_TEXT, theme: 'tooltip-danger' }"
                  >
                    <img class="card__icon icon icon--danger" src="~images/info.svg" v-svg-inline/>
                  </span>
                </span>
              </td>
              <td class="table__td" data-title="Обновлено">{{ application.updated_at }}</td>
              <td class="table__td" data-title="Действия">
                <div>
                  <button
                    class="btn btn--primary"
                    :disabled="isImporting"
                    @click="startImport(application)"
                  >
                    <t-loader
                      v-if="isApplicationImporting(application)"
                      size="sm"
                      tone="inherit"
                      :text="progressMessage || 'Обновляем'"
                    />
                    <template v-else>Обновить</template>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <template v-else-if="readonly">
      <div class="card card--info">
        <img class="card__icon icon icon--primary" src="~images/info.svg" v-svg-inline/>
        <p>Заявления не найдены</p>
      </div>
    </template>

    <applications-search v-else-if="!readonly" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { APPLICATION_EMAIL_NOT_MATCHED_TEXT } from '@shared/config'
import { TLoader } from '@shared/ui'
import { useFormApplicationImport } from '../../model/useFormApplicationImport'
import ApplicationsSearch from '../applications/ApplicationsSearch.vue'

const props = defineProps({
  applications: { type: Array, default: () => [] },
  readonly: { type: Boolean, default: false },
  formId: { type: [String, Number], default: null },
})

const emit = defineEmits(['select', 'refetch-form'])

const hasBeenEnrolled = computed(() => props.applications.some(item => item.status === 'enrolled'))

const {
  progressMessage,
  isImporting,
  startImport,
  isApplicationImporting,
} = useFormApplicationImport({
  applications: computed(() => props.applications),
  formId: computed(() => props.formId),
  onFinished: () => emit('refetch-form'),
})
</script>
